
Drupal.behaviors.primaryMenu = {
  attach: function (context, settings) {
    once('armed', 'body', context).forEach(el => {
      initFlowbite();
    });

    once('armed', '.burger-button', context).forEach(burgerButton => {
      burgerButton.addEventListener('click', () => {
        burgerButton.querySelectorAll('.tham').forEach(tham => {
          tham.classList.toggle('tham-active');
        })
      });
    });
  },
};

Drupal.behaviors.wingsuitMenu = () => {
  return {
    submenuIsOpen: false,
    processed: false,
    submenuDirection: 'right',
    getSubmenuDirection: ($el) => {
      const space = $el.getBoundingClientRect().width + $el.getBoundingClientRect().x + 400;
      return space >= window.innerWidth ? 'left' : 'right';
    },
  };
};
